import  CloudIcon from '@material-ui/icons/Cloud';
import CreateNewFolderIcon from '@material-ui/icons/CreateNewFolder';

const icons = {
    cloud: 'custom-cloud-icon'
}
export default icons